export const openUrl = (url: string, target: string = '_blank') => {
  window.open(url, target);
};



// WEBPACK FOOTER //
// ./src/actions/open.ts